import { MapPinIcon, UsersIcon, ShieldIcon, SmartphoneIcon } from "../ui/Icons";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/Card";

const features = [
  {
    icon: MapPinIcon,
    title: "Real-time Safety Zones",
    description: "Get live updates on safe areas, well-lit streets, and areas to avoid based on recent traveler experiences.",
    color: "text-green-600",
    bgColor: "bg-green-100"
  },
  {
    icon: UsersIcon,
    title: "Community Reviews",
    description: "Read honest reviews from women travelers about accommodations, transport, and local experiences.",
    color: "text-red-500",
    bgColor: "bg-red-100"
  },
  {
    icon: ShieldIcon,
    title: "Verified Traveler Network",
    description: "Connect with verified women travelers for tips, meetups, and emergency support in real-time.",
    color: "text-purple-500",
    bgColor: "bg-purple-100"
  },
  {
    icon: SmartphoneIcon,
    title: "Mobile-First Design",
    description: "Access safety information instantly on your phone, even with limited internet connectivity.",
    color: "text-teal-600",
    bgColor: "bg-teal-100"
  }
];

export const FeaturesSection = () => {
  return (
    <section id="features" className="section-mobile bg-gray-50">
      <div className="max-w-7xl mx-auto container-mobile">
        <div className="text-center section-gap-mobile">
          <h2 className="mobile-heading-2">
            Everything You Need to Travel Safely
          </h2>
          <p className="mobile-body-text max-w-3xl mx-auto">
            Crowdsourced wisdom from thousands of women travelers, updated in real-time 
            to keep you informed and confident on your journeys.
          </p>
        </div>

        <div className="features-mobile card-stack-mobile md:grid-cols-2 lg:grid-cols-4">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card 
                key={feature.title} 
                className="card-mobile hover:shadow-lg transition-all duration-300 transform hover:scale-105 border-0 shadow-md"
              >
                <CardHeader className="text-center">
                  <div className={`w-16 h-16 ${feature.bgColor} rounded-2xl flex items-center justify-center mx-auto mb-4`}>
                    <Icon className={`w-8 h-8 ${feature.color}`} />
                  </div>
                  <CardTitle className="text-xl font-semibold">{feature.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-center text-gray-600 leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};